module.exports = __webpack_public_path__ + "static/media/4-2.9a98218b.mp3";